import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import * as yup from "yup";
import { cleannerError, onHide } from "../../../../utils/utils";
import { BtnSubmit } from "../../../common/Button";
import { FormError } from "../../../common/Input";
import CloseModalBtn from "../../../shared/CloseModalBtn";
import { DemandeSupAccount } from "../../../../utils/api/user/user.type";
import { useEditDemandeSupCompteMutation } from "../../../../utils/api/user/user.api";
import { toast } from "react-hot-toast";

type DemandeSupFormData = {
	status: string;
	motif?: string;
};

function ChangeStatusDemandeSupModal({
	modalId,
	item,
}: {
	modalId: string;
	item?: DemandeSupAccount;
}) {
	const [isShowMotifField, setIsShowMotifField] = useState<boolean>(false);
	const validationSchema = yup.object().shape({
		status: yup.string().required().label("Status"),
		motif: yup.string().when("status", {
			is: "refusee",
			then: yup.string().required().label("Motif"),
		}),
	});
	const [changeStatus, { isLoading }] = useEditDemandeSupCompteMutation();
	const {
		register,
		handleSubmit,
		formState: { errors },
		clearErrors,
		setValue,
		reset,
	} = useForm<DemandeSupFormData>({
		resolver: yupResolver(validationSchema),
	});

	useEffect(() => {
		if (item?.slug) {
			setValue("status", item?.status);
		}
	}, [item]);

	useEffect(() => {
		if (errors) {
			return cleannerError(errors, clearErrors);
		}
	}, [errors]);

	const handleShowMotifField = (e: React.ChangeEvent<HTMLSelectElement>) => {
		if (e.currentTarget.value === "refusee") {
			setIsShowMotifField(true);
		} else {
			setIsShowMotifField(false);
		}
	};

	const onSubmit = async (data: DemandeSupFormData) => {
		let newData: { status: string; motif?: string } = { status: data.status };
		if (data.motif) newData.motif = data.motif;

		const res = await changeStatus({ slug: item?.slug as string, data: newData });
		if ("data" in res) {
			const { status } = data;
			let message =
				status === "acceptee"
					? "La demande de suppression a été acceptée. Le compte a été supprimé."
					: "La demande de suppression a été refusée. Le patient a été notifié.";
			reset();
			onHide(modalId);
			toast.success(message);
		} else if ("error" in res) {
			const err = res.error as any;
			Swal.fire({
				icon: "error",
				title: `${
					err?.data?.message
						? err?.data?.message
						: `Une erreur de status ${err?.status} a survenu!`
				}`,
				showConfirmButton: false,
				timer: 2000,
			});
		}
	};
	return (
		<div
			className="modal fade"
			id={modalId}
			aria-labelledby="ChangeStatusDemandeSupModalLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal-dialog-centered modal-md">
				<div className="modal-content">
					<div className="modal-header">
						<h5
							className="modal-title modal-title-custom fw-500 fs-20"
							id="ChangeStatusDemandeSupModal"
						>
							Traiter la demande de suppression
						</h5>
						<CloseModalBtn />
					</div>
					<div className="modal-body justify-content-start w-100">
						<form className="w-100" onSubmit={handleSubmit(onSubmit)}>
							<div className="row">
								<div className="col-md-12 mb-3">
									<div>
										<label className="form-label label-form-admin">
											Statut de la demande
											<span className="text-danger">*</span>
										</label>
										<select
											className="form-control form-control-input-admin py-3"
											id="status"
											{...register("status")}
											onChange={handleShowMotifField}
										>
											<option value="nouvelle">Nouvelle</option>
											<option value="acceptee">Accepter (supprimer le compte)</option>
											<option value="refusee">Refuser</option>
										</select>
										<FormError error={errors?.status} />
									</div>
								</div>
								{isShowMotifField && (
									<div className="col-12">
										<label className="form-label label-form-admin">
											Motif
											<span className="text-danger">*</span>
										</label>
										<textarea
											className="form-control form-control-modal"
											rows={4}
											{...register("motif")}
											placeholder="Motif de refus"
										/>
										<FormError error={errors?.motif} />
									</div>
								)}
							</div>
							<div className="flex-end mt-5 gap-4">
								<BtnSubmit label="Enregistrer" isLoading={isLoading} />
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ChangeStatusDemandeSupModal;
